import { render, staticRenderFns } from "./CustomerFormContent.vue?vue&type=template&id=27448ae7&scoped=true&"
import script from "./CustomerFormContent.vue?vue&type=script&lang=js&"
export * from "./CustomerFormContent.vue?vue&type=script&lang=js&"
import style0 from "./CustomerFormContent.vue?vue&type=style&index=0&id=27448ae7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27448ae7",
  null
  
)

export default component.exports